import { useState, useEffect } from 'react';
import api from '../myApi';

export function ScheduleData(endpoint, param, vo = null) 
{
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => 
    {
        const fetchData = async () => 
        {
            try 
            {
                setLoading(true);

                let url = param ? `${endpoint}/${encodeURIComponent(param)}` : endpoint;
                
                if (vo !== null) 
                    url += `?vo=${vo}`;

                const response = await api.get(url);
                
                if (response.data) 
                    setData(response.data);
            } 
            catch (err) 
            {
                setError('Ошибка загрузки данных');
                console.error('Ошибка:', err);
            } 
            finally 
            {
                setLoading(false);
            }
        };

        fetchData();
        
    }, [endpoint, param, vo]);

    return { data, loading, error };
}

export default ScheduleData;